<div class="error-page-container">
  <div class="content">
    <h1 class="error-code">404</h1>
    <h2 class="error-title">Page not found</h2>
    <p class="error-message">
      The page you are looking for seems to have drifted away or does not exist.
      Let's get you back on course.
    </p>

    <button (click)="goHome()" class="btn-primary-action">Go back</button>
  </div>

  <div class="ocean">
    <div class="wave"></div>
    <div class="wave"></div>
  </div>
</div>
